import { Loading } from '../common';

  export const LoaderPop=()=> {
  return (
        <div className="loading-overlay">
            <div className="loading-box">
                 <Loading /> Please wait while we load the necessary data...
            </div>
        </div>
  )
}
